import { Record } from "immutable";
import { v4 as uuidV4 } from "uuid";

export const commissionStepfromJSON = (json: Partial<ICommissionStepData>): CommissionStepRecord => {
  const record: ICommissionStepRecord = { ...(json as any) };
  return new CommissionStepRecord(record);
};

type DisplayOptions = "percent" | "currency" | "hidden" | "none";

export interface ICommissionStepData {
  name: string;
  formula: string;
  title: string;
  display_format: "percent" | "currency" | "hidden" | "none";
  id?: string;
}

export interface ICommissionStepRecord {
  name: string;
  formula: string;
  title: string;
  display_format: "percent" | "currency" | "hidden" | "none";
  id: string;
}

export const defaultCommissionStepProps = {
  name: "",
  formula: "",
  title: "",
  display_format: "none" as DisplayOptions,
  id: uuidV4(),
};

export class CommissionStepRecord
  extends Record<ICommissionStepRecord>(defaultCommissionStepProps)
  implements ICommissionStepRecord {}
